import { render } from "./AdmPaymentMng.vue?vue&type=template&id=4fcfe703&scoped=true"
import script from "./AdmPaymentMng.vue?vue&type=script&lang=js"
export * from "./AdmPaymentMng.vue?vue&type=script&lang=js"

import "./AdmPaymentMng.vue?vue&type=style&index=0&id=4fcfe703&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcfe703"]])

export default __exports__